"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMagnifierIcon = void 0;
var createMagnifierIcon = function createMagnifierIcon() {
  var magnifyIcon = document.createElement('div');
  magnifyIcon.className = 'cloudimage-360-magnifier-icon';
  return magnifyIcon;
};
exports.createMagnifierIcon = createMagnifierIcon;